import { Alert, Box, Stack } from "@mui/material";

const SmsMonitoringAlerts = ({ alerts = [] }) => {
  if (!alerts.length) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Stack spacing={1}>
        {alerts.map((alert, index) => (
          <Alert key={`${alert.message}-${index}`} severity={alert.severity || "info"}>
            {alert.message}
          </Alert>
        ))}
      </Stack>
    </Box>
  );
};

export default SmsMonitoringAlerts;
